import { useFormikContext } from 'formik';
import { LaunchpadCard } from '../../ui/LaunchpadCard';
import { TwoColumnGridContainer } from '../../ui/TwoColumnGridContainer';
import { DefaultFastTextField } from '../../mui-overrides/Textfield';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const NotaryInfoSection = () => {
  const formik = useFormikContext();
  const { t } = useTranslation();

  return (
    <LaunchpadCard title={t('dashboard.assets.notary.info.title')}>
      <TwoColumnGridContainer>
        <div>
          <DefaultFastTextField type="text" label={t('dashboard.assets.notary.info.fields.name')} fieldName="name" formik={formik} />
        </div>
        <div>
          <DefaultFastTextField type="text" label={t('dashboard.assets.notary.info.fields.email')} fieldName="email" formik={formik} />
        </div>
      </TwoColumnGridContainer>
      <Button variant="contained" color="primary" disableElevation disabled={false} type="submit" data-cy="asset-investment-save-button">
        {t('dashboard.assets.addedit.investment.save')}
      </Button>
    </LaunchpadCard>
  );
};
